<!--
  `?auth_error=<code>` on a landing page.

  The browser navigations at /auth/link and /auth/callback/google cannot answer
  with JSON -- a person is looking at the result -- so they redirect back to a
  page carrying a code. Without this the person lands on a perfectly normal
  signed-out page with no idea why, which is the worst possible answer to
  "I clicked the link in my email and nothing happened".

  The codes are the ones packages/server/src/http/routes.ts actually emits.
  Anything unrecognised still gets a sentence, because a code added tomorrow
  should not produce a blank.
-->
<script lang="ts">
  import { router } from '../router.svelte'

  const code = $derived(router.query.get('auth_error'))

  const message = $derived.by(() => {
    if (!code) return null
    switch (code) {
      case 'link_invalid':
        return 'That sign-in link has already been used, or it expired. Ask for a new one.'
      case 'signup_not_permitted':
        return 'That email address is not allowed to sign up on this server. Ask an administrator to add your domain.'
      case 'state_mismatch':
        return 'That sign-in attempt could not be verified — it may have been started in another tab or taken too long. Try again.'
      case 'google_unavailable':
        return 'Google sign-in is not configured on this server. Sign in with your email address instead.'
      case 'google_no_code':
      case 'google_failed':
        return 'Google sign-in did not complete. Try again, or use your email address.'
      case 'google_access_denied':
        return 'You cancelled the Google sign-in. Try again, or use your email address.'
      case 'server_error':
        return 'Something went wrong at our end while signing you in. Try again.'
      default:
        if (code.startsWith('google_')) {
          return 'Google sign-in did not complete. Try again, or use your email address.'
        }
        return 'Sign-in did not complete. Try again.'
    }
  })
</script>

{#if message}
  <div class="notice" role="alert">
    <p>{message}</p>
    <p>
      <button type="button" class="linkish" onclick={() => router.dropQuery('auth_error')}
        >Dismiss</button
      >
    </p>
  </div>
{/if}
